import { Component, input, computed, inject, viewChild, forwardRef } from '@angular/core';

import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DialogInsService } from '../../dialog/dialog-ins.service';
import { FilterDataDialogComponentData } from '../filter-data-dialog/filter-data-dialog-component';
import { SortDataDialogComponent, SortDataDialogComponentData } from '../sort-data-dialog/sort-data-dialog-component';
import { compareChipsValues, resetChips } from '../../filter-chips/filter-chips';
import { DrawerService } from '../../drawer/drawer.service';
import { FilterChipsComponent } from '../../filter-chips/filter-chips.component';
import { FilterDrawerComponent } from '../filter-drawer/filter-drawer.component';

@Component({
	selector: 'skl-filtering-data-panel',
	templateUrl: './filtering-data-panel.component.html',
	styleUrls: ['./filtering-data-panel.component.scss'],
	imports: [TranslatePipe, forwardRef(() => FilterDrawerComponent), FilterChipsComponent]
})
export class FilteringDataPanelComponent {
	protected readonly dialogService = inject(DialogInsService);
	protected readonly drawerService = inject(DrawerService);

	public sortData = input<SortDataDialogComponentData>();
	public filterData = input<FilterDataDialogComponentData>();

	public readonly filterDrawer = viewChild(FilterDrawerComponent);

	public readonly badgeCount = computed(() => {
		const chips = this.filterData()?.filterOptions?.chips;
		if (!chips) return 0;

		return chips.filter(c => compareChipsValues(c.value, c.defaultValue)).length;
	});

	public onClick(type: 'sort' | 'filter') {
		if (type === 'filter') {
			this.filterDrawer()?.open();
			return;
		}

		const data = {
			component: SortDataDialogComponent,
			componentProps: {
				data: this.sortData()
			}
		};
		this.dialogService.showAsync(data);
	}

	public onReset() {
		const chips = this.filterData()?.filterOptions?.chips;
		if (chips) {
			resetChips(chips);
		}
	}

}
